module.exports = __webpack_public_path__ + "img/ai-th.66092af.png";